import moment from 'moment';

/**
 * Gate for trip CSV export. Mirrors TripHistory.handleExportClick:
 * a date range is required and may not exceed 365 days.
 * @param {string} fromDate - 'MM/DD/YYYY HH:mm:ss'
 * @param {string} toDate   - 'MM/DD/YYYY HH:mm:ss'
 * @returns {{ ok: boolean, reason: 'missing_dates'|'range_too_large'|null }}
 */
export const exportDateGuard = (fromDate, toDate) => {
	if (!fromDate || !toDate) {
		return { ok: false, reason: 'missing_dates' };
	}
	const diff = moment(toDate).diff(moment(fromDate), 'days');
	if (diff > 365) {
		return { ok: false, reason: 'range_too_large' };
	}
	return { ok: true, reason: null };
};
